import React from 'react';
import PropTypes from 'prop-types';

import { SiInstagram, SiWhatsapp } from 'react-icons/si';
import { FaPhone, FaEnvelope } from 'react-icons/fa';

PageTitle.propTypes = {};

function PageTitle(props) {
  const { title } = props;
  return (
    <section className="page-title">
      <div className="shape"></div>
      <div className="shape right s3"></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title__body">
              <div className="page-title__main">
                <h4 className="title">{title}</h4>

                <ul className="breacrumb">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <p>Explore</p>
                  </li>
                  <li>
                    <p>{title}</p>
                  </li>
                </ul>

                <div className="bottom">
                  <p>Follow us</p>

                  <ul className="list-social">
                    <li>
                      <a
                        href="https://instagram.com/nxtlvlnights"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        data-net="ig"
                      >
                        <SiInstagram />
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://wa.me/16892679495"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="WhatsApp"
                        data-net="wa"
                      >
                        <SiWhatsapp />
                      </a>
                    </li>

                    <li>
                      <a href="tel:+16892679495" aria-label="Phone" data-net="phone">
                        <FaPhone />
                      </a>
                    </li>

                    <li>
                      <a href="mailto:vip@nxtlvlnights.com" aria-label="Email" data-net="mail">
                        <FaEnvelope />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PageTitle;
